import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/apiClient";
import { Moon, ArrowRight } from "lucide-react";

export default function TonightCard() {
  const navigate = useNavigate();
  const [inst, setInst] = useState(null);
  const evening = new Date().getHours() >= 20 || new Date().getHours() < 4;
  useEffect(() => { if (evening) api.get("/tonight").then((r) => setInst(r.data.installation)).catch(() => {}); }, [evening]);
  if (!evening || !inst) return null;
  return (
    <motion.button initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.45 }}
      onClick={() => navigate(`/inner/${inst.id}${inst.sleep ? "?mode=sleep" : ""}`)} data-testid="home-tonight"
      className="w-full mb-6 text-left rounded-3xl border border-indigo-300/20 bg-gradient-to-br from-[#0b1026] to-[#121a3a] p-5 flex items-center gap-4 group">
      <span className="w-11 h-11 rounded-full bg-indigo-300/10 flex items-center justify-center shrink-0"><Moon className="w-5 h-5 text-indigo-200" /></span>
      <span className="flex-1 min-w-0">
        <span className="block text-[11px] uppercase tracking-[0.2em] text-indigo-200/80">Tonight</span>
        <span className="block font-serif text-lg text-white truncate">{inst.title}</span>
        <span className="block text-xs text-white/60">{inst.sleep ? `Sleep version${inst.duration ? ` · ${inst.duration}` : ""} — let her guide you to rest` : "Wind down with your coach"}</span>
      </span>
      <ArrowRight className="w-4 h-4 text-white/60 transition-transform duration-300 group-hover:translate-x-1" />
    </motion.button>
  );
}
